import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {setDisplayNone} from '../utils';
import {
  USYS_DATA_ATTRS,
  USYS_FORM_TYPES,
} from '@packages/systems/users/constants';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import {pluginName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const UserSignUpForm = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild, context}) => {
    const siteKey = context.getIn(['usysCaptcha', 'siteKey']);
    const mode = context.getIn(['usysCaptcha', 'mode']);

    const hideForm =
      context.get('formState') === 'success' ||
      context.get('formStatus') === 'verification';
    const props = generateAttributes(
      siteKey && mode
        ? attributes
            .set('wf-captcha-site-key', siteKey)
            .set('wf-captcha-mode', mode)
        : attributes,
      classes
    );
    const displayProps = hideForm
      ? {
          ...props,
          style: setDisplayNone(props.style),
        }
      : props;

    return (
      <form
        {...displayProps}
        method="post"
        {...{[USYS_DATA_ATTRS.formType]: USYS_FORM_TYPES.signup}}
      >
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, context)
        )}
      </form>
    );
  }
);

const config = Atom.create({
  constraints: {
    ancestors: [{is: 'UserSignUpFormWrapper', rule: 'ExactlyOne'}],
    page: [
      {
        type: 'UtilityPage',
        is: 'usys-sign-up',
      },
    ],
    descendants: [
      {
        is: 'UserFormEmailInput',
        rule: 'ExactlyOne',
      },
      {
        is: 'UserFormNameInput',
        rule: 'ZeroOrOne',
      },
      {
        is: 'UserFormPasswordInput',
        rule: 'ExactlyOne',
      },
      {
        is: 'UserFormButton',
        rule: 'ExactlyOne',
      },
      {
        is: 'UserSignUpTermsOfServiceWrapper',
        rule: 'ZeroOrOne',
      },
      {
        is: 'UserFormFileUploadInput',
        rule: 'ZeroOrOne',
      },
    ],
    pinToParent: true,
  },
  displayName: 'Sign Up Form',
  render: UserSignUpForm,
  showEmpty: true,
  dataType: createIntegratedRootAliasInstance(
    qualify(pluginName('Users'), typeName('UserForm'))
  ),
  showSettingsInDescendants: true,
});

export default config;
